/* -------------------------------------------------------------------------- */
/*                                   Config                                   */
/* -------------------------------------------------------------------------- */

import { uuid } from '@utils/functions';

interface Step {
	key: string;
	label: string;
}

export const STEPS: Step[] = [
	{
		key: uuid(),
		label: 'offsets.stepper.step1',
	},
	{
		key: uuid(),
		label: 'offsets.stepper.step2',
	},
	{
		key: uuid(),
		label: 'offsets.stepper.step3',
	},
	{
		key: uuid(),
		label: 'offsets.stepper.step4',
	},
];
